import gql from 'graphql-tag';

export default gql`
mutation updateTableOrderItemStatus(
    $id: String! 
    $subOrderId: String! 
    $serviceId: String!
    $status: RESTAURANT_ORDER_STATUS!
    $qty:Float
    $rejectReason: String
    ){
    updateTableOrderItemStatus(input:{
      id: $id 
      subOrderId: $subOrderId 
      serviceId: $serviceId
      status: $status
      qty:$qty
      rejectReason:$rejectReason
    }){
     id
      orderId
      parentOrderRef
      noOfGuest
      counterId
      tokenId
      externalOrderId
      aggregatorSystem
      callbackUrl
      siteId
      name
      mobile
      email
      custId
      customerSegment
      countryCode
      createdBy
     reopenedAt
     syncTimestamp
      address
      address1
     custAddress {
        addressLineOne
        addressLineTwo
        locality
        city
        state
        zip
        country
      }
      date
      otp
      source
      orderFrom
      subOrderFrom
      orderEnabled
      timestamp
      taxAmt
      preparationTime
      aggregatorOrderId
      orderSource
      updatedAt
      grandTotal
      tableNo
      blockedTables
      finalAmount
      pendingOrderStatus
      orderStatus
      discountAmt
      discountType
      shippingAmount
      couponCode
      remarks
      rewardPoints
      rewardAmt
      orderCreatedFrom
      paymentMode
      paymentState
      updatedBy
      paymentStatus
      customerSegment
      rejectReason
      paidAmt
      balanceAmt
      tableOrderStatus
      isBillGenerated
      ignoreTax
      convertedCurr
      deliveryTimestamp
      approvalStatus
      qrData
      primaryWaiter
      area
      captain
          orderTags {
      tag_type
      content
        }
      rider {
        id
        name
        mobile
        status
        orderId
        otp
        otpMessage
      }
       additionalRider{
         id
        name
        mobile
        status
        orderId
        otp
        otpMessage
        }
      otherCharges{
        name
        rate
        type
        title
        tax
        amt
        taxType
        defaultSelcted
        chargesAppliedOnInclusive
      }
      taxation {
            taxType
            taxSubType
            taxRate
            taxableAmt
          }
      appliedDiscounts{
        type
        discountName
        discountType
        discountValue
        discountAmt
        discountId
        note
        actionedBy
      }
      customFeilds{
        customName
        customType
        customValue
        required
        availability
      }
   
      orderList{
        subOrderId
        totalPrice
        createdAt
        createdBy
        services{
          serviceId
          masterProdId
          courseFiredAt 
          refId
          serviceName
          serviceRate
          metaKeyword
          serviceAmount
          discountAmt
          discountType
          isUrgent
          uId
          courseId
          pmInventory
          isInvWastage
          purchaseItemRef
          noDiscountItem
          costPrice
          departmentId
          itemUnit
          hsnCode
          incentive
          refId
          attachedCat
          instruction
          qty
          reqQty
          tax
          taxAmt
          taxType
          itemType
          status
          station
          rejectReason
          kotId
          isKotPrinted
          inprocessAt
          cancelledAt
          kotgeneratedAt
          preparedAt
          completedAt
          discounts{
           type
            discountType
            discountValue
            discountAmt
            discountName
            discountId
            note
          }
          addons{
            attachedAddonCat
            isCustomQty
            serviceName
            serviceRate
             qty
             serviceId
             tax
             station
             isInventory
             pmInventory
             purchaseItemRef
             noDiscountItem
             costPrice
             departmentId
             itemUnit
             hsnCode
             incentive
             refId
           }
        }
        customFeilds{
          customName
          customType
          customValue
          required
        }
      }
    }
  }`;

    // {
    //    "id": "b148b379-a018-44e3-ae54-644bac405262:::10",
    //    "subOrderId": "10/1",
    //    "serviceId": "papad",
    //    "status": "KOT_GENERATED"
    //  }
    